import { render, staticRenderFns } from "./setPerson.vue?vue&type=template&id=37df2dd3&"
import script from "./setPerson.vue?vue&type=script&lang=js&"
export * from "./setPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports